import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CreateTemplateComponent } from './create-template.component';
import { 
  ButtonModule,
  ToggleModule,
  TooltipModule,
  InputsModule
} from '@xref/xref-lib';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SendXrefModule } from '../../components/send-xref/send-xref.module';
import { SelectedQuestionnaireModule } from '../../components/send-xref/components/selected-questionnaire/selected-questionnaire.module';
import { LoaderModule } from '../../components/loader/loader.module';

@NgModule({
  declarations: [
    CreateTemplateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ButtonModule,
    ToggleModule,
    InputsModule,
    ModalModule,
    SendXrefModule,
    TooltipModule,
    SelectedQuestionnaireModule,
    LoaderModule
  ],
  exports: [CreateTemplateComponent]
})
export class CreateTemplateModule { }

